const state = {};
const actions = {
  chkValidPw({ state, commit, dispatch }, password) {
    let ProcessType = false;
    let pwLen = password.length;
    let bChar1 = false;
    let bChar2 = false;
    let bChar3 = false;

    /* 숫자 포함 확인 */
    for (let i = 0; i < pwLen; i++) {
      let chkIdx = password.charCodeAt(i);

      if (chkIdx >= 48 && chkIdx <= 57) {
        bChar1 = true;
        break;
      }
    }

    if (bChar1 == true) {
      /* 숫자 포함 및 영문자 확인 */
      for (let i = 0; i < pwLen; i++) {
        let chkIdx = password.charCodeAt(i);

        if ((chkIdx >= 65 && chkIdx <= 90) || (chkIdx >= 97 && chkIdx <= 122)) {
          bChar2 = true;
          break;
        } else {
          return ProcessType;
        }
      }
    }
    if ((bChar1 && bChar2) == true) {
      /* 숫자, 영문자 포함 및 특수문자 확인 */
      for (let i = 0; i < pwLen; i++) {
        let chkIdx = password.charCodeAt(i);
        if (
          (chkIdx >= 32 && chkIdx <= 47) ||
          (chkIdx >= 58 && chkIdx <= 64) ||
          (chkIdx >= 91 && chkIdx <= 96) ||
          (chkIdx >= 123 && chkIdx <= 126)
        ) {
          bChar3 = true;
          break;
        }
      }
    } else {
      return ProcessType;
    }
    if (bChar1 && bChar2 && bChar3) ProcessType = true;
    return ProcessType;
  }
};
const mutations = {};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/module/common/chkPw.js